export default "__VITE_ASSET__68mEVcXd__"